import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignCenter: RibbonButton = {
    key: 'alignCenter',
    title: () => strings.alignCenter,
    imageSrc: require('../svg/aligncenter.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Center);
        logUsage('setAlignment', Alignment.Center);
    },
};

export default alignCenter;
